import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { inputBaseClassName } from '@/components/ui/input';

interface PhoneInputProps {
  value?: string;
  onAccept: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  disabled?: boolean;
  /** Aceita também telefone fixo (00) 0000-0000. Padrão: apenas celular (00) 00000-0000 */
  allowLandline?: boolean;
}

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ value, onAccept, onBlur, placeholder, disabled, allowLandline = false }, ref) => {
    return (
      <IMaskInput
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mask={(allowLandline ? ['(00) 0000-0000', '(00) 00000-0000'] : '(00) 00000-0000') as any}
        className={inputBaseClassName}
        value={value ?? ''}
        onAccept={onAccept}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        inputRef={ref}
      />
    );
  }
);
PhoneInput.displayName = 'PhoneInput';
